import rest from '@modules/rest'
import upload from '@modules/upload'
import { getUploadEndpoint, getFileUrl } from '@modules/fileHelpers'
import * as get from '@graphql/queries'
import middleware from '@graphql/middleware'
import {
  mapEducation,
  mapEducationInput,
} from '@convenia/common-organisms/SystemFields/content/mappers/education'

export async function getOptions () {
  const [ err, data ] = await middleware(get.GetFormationOptions)
  const options = {
    formation: {
      educationTypes: data.educationTypes
    }
  }

  return [ err, options ]
}

export const getFormations = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/employee`
    const { data = [] } = await rest.get(url)

    const formations = data
      .map(formation => mapEducation(formation, { employeeId, getFileUrl }))

    return [ null, formations ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createFormation = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/employee`
    const body = mapEducationInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const formation = mapEducation(response.data, { employeeId, getFileUrl })

    return [ null, formation ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateFormation = async (data, params) => {
  try {
    const formationId = data?.id
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/${formationId}/employee`
    const body = mapEducationInput({ data, schema })

    await rest.put(url, { body, headers: { bcv: true } })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteFormation = async (data, params) => {
  try {
    const formationId = data?.id
    const isCreating = typeof formationId !== 'string'

    if (isCreating)
      return [ null, null ]

    const { employeeId, companyId } = params

    await rest.delete(`/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/${formationId}/employee`)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadFormationFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'education')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}
